import { OrganizationConfig } from '@tenants/types/tenant';
import {
  getSubDomainUrlWithPath,
  RootDomain,
} from 'constants/domains';

export function createOrganizationConfig(rootDomain: RootDomain): OrganizationConfig {
  return {
    phoneNumber() {
      return '1 844-539-0722';
    },
    email() {
      return 'info@expcommercial.com';
    },
    address(_options) {
      return '2219 Rimland Drive, Suite 301,<br />Bellingham, Washington, 98226';
    },
    companyInfo1: 'eXp Commercial of California, Inc. | CA DRE # 01208047 | Jeffrey Peldon - Designated Broker',
    companyInfo2: 'Clifford Bogart - Designated Broker - TX',
    twitterUrl: 'https://x.com/exprealty',
    facebookUrl: 'https://www.facebook.com/profile.php?id=100065096766753',
    instagramUrl: 'https://www.instagram.com/exp.commercial/',
    linkedinUrl: 'https://www.linkedin.com/company/exp-commercial/',
    youtubeUrl: 'https://www.youtube.com/@eXpCommercial',
    joinSectionUrl: getSubDomainUrlWithPath(rootDomain, 'www', '/become-an-advisor'),
  };
}
